module.exports = __webpack_public_path__ + "img/user.d1640a08.png";